import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    walletBalnceRes: [],
    currencyRes: [],
    error: "",
}



const walletBalanceSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {
        balance: (state, action) => {
            state.walletBalnceRes = action.payload
        },

        Currencylist: (state, action) => {

            state.currencyRes = action.payload
        },
    }
})

export const { balance, Currencylist } = walletBalanceSlice.actions;

export default walletBalanceSlice.reducer;

export const getWalletBalance = (callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.GetData(`${frontUrl}/${API?.GET_USER_WALLET_BALANCE}`);
            callback(response);
            dispatch(balance(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

export const currencyreq = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.CURRENCY_LIST}`, data);
            callback(response);
            dispatch(Currencylist(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };